import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Magnetic from './Magnetic';

/**
 * Pill Apply CTA, magenta body, white text, white circle with arrow.
 * Use for InnovAce (/apply) and Contact Us (/contact).
 */
export default function ApplyCta({
  to = '/apply',
  label = 'Apply',
  className = '',
  size = 'md',
  variant = 'primary',
  magnetic = true,
}) {
  const sizes = {
    sm: 'pl-5 pr-1.5 py-1.5 text-sm',
    md: 'pl-7 pr-2 py-2.5 text-base',
    lg: 'pl-8 pr-2.5 py-3 text-base sm:text-lg',
  };
  const iconSizes = {
    sm: 'w-7 h-7',
    md: 'w-9 h-9',
    lg: 'w-10 h-10',
  };
  const arrowSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-4 h-4',
    lg: 'w-4 h-4',
  };

  const variants = {
    primary:
      'bg-[#d42b92] text-white shadow-[0_15px_50px_-10px_rgba(212,43,146,0.55)] hover:bg-white hover:text-black [&_span]:bg-white [&_span]:text-[#d42b92] hover:[&_span]:bg-[#d42b92] hover:[&_span]:text-white',
    secondary:
      'bg-transparent text-white border border-white/20 hover:border-[#d42b92] hover:text-[#ff8ec5] [&_span]:bg-[#d42b92] [&_span]:text-white',
    light:
      'bg-white text-black hover:bg-[#d42b92] hover:text-white [&_span]:bg-[#d42b92] [&_span]:text-white hover:[&_span]:bg-white hover:[&_span]:text-[#d42b92]',
  };

  const btn = (
    <Link
      to={to}
      data-cursor="hover"
      className={`group inline-flex items-center gap-2 rounded-full font-medium transition-colors duration-300 ${sizes[size]} ${variants[variant] || variants.primary} ${className}`}
    >
      {label}
      <span
        className={`${iconSizes[size]} rounded-full grid place-items-center group-hover:rotate-45 transition`}
      >
        <ArrowUpRight className={arrowSizes[size]} />
      </span>
    </Link>
  );

  if (!magnetic) return btn;
  return <Magnetic>{btn}</Magnetic>;
}
